import { TOGGLE_FIRST_VIDEO_SHARE_MODAL } from 'constants/actions';

export const toggleFirstVideoShareModalIsOpen = isOpen => {
  return {
    type: TOGGLE_FIRST_VIDEO_SHARE_MODAL,
    isOpen,
  };
};
